// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "f805759d01f41de78d94" + "/js/" + chunkId + ".js";
};